import React, { Component } from 'react'
import LogoStyles from './Logo.styled';


const Logo  = ({handleClick})=> {
  return (<LogoStyles>
        <a className="logoCon" href="https://claytonhomes.com" target="_blank" rel="noopener noreferrer" onClick={handleClick}>
          <h1 className="logo">Clayton Homes</h1>
        </a>
  </LogoStyles>);
}

export default Logo;
